export default function GetStartedCard({
  title = "Get Started in Minutes",
  desc = "Experience the power of automation with FleetRobo® AIS-140 ICAT Certified Devices",
  primaryText = "Explore Solutions",
  secondaryText = "Contact us",
  primaryHref = "/services",
  secondaryHref = "/contact",
  className = "",
}) {
  return (
    <div
      className={`rounded-xl bg-gradient-to-r from-[#ed860f] via-[#a4632d] to-[#090b5c] px-6 py-10 sm:px-10 sm:py-12 lg:px-16 lg:py-14 ${className}`}
    >
      <h2 className="text-2xl font-bold leading-tight text-black sm:text-3xl lg:text-[34px]">
        {title}
      </h2>

      <p className="mt-3 max-w-[720px] text-xs leading-relaxed text-black/80 sm:text-sm">
        {desc}
      </p>

      <div className="mt-7 flex flex-col gap-4 sm:flex-row sm:flex-wrap">
        {/* {primaryText ? (
          <a
            href={primaryHref}
            className="inline-flex min-h-11 items-center justify-center rounded-md bg-white px-8 py-3 text-sm font-medium text-[#ed860f] transition hover:bg-white/90"
          >
            {primaryText}
          </a>
        ) : null} */}

        {secondaryText ? (
          <a
            href={secondaryHref}
            className="inline-flex min-h-11 items-center justify-center rounded-md border border-white px-8 py-3 text-sm font-medium text-white transition hover:bg-white hover:text-black"
          >
            {secondaryText}
          </a>
        ) : null}
      </div>
    </div>
  )
}
